if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
        
        // Ajouter la fonctionnalité de navigation desktop pour les thumbnails
        this.setupDesktopThumbnailNavigation();
      }

      setupDesktopThumbnailNavigation() {
        if (!this.elements.thumbnails) return;
        
        const prevButton = this.elements.thumbnails.querySelector('button[name="previous"]');
        const nextButton = this.elements.thumbnails.querySelector('button[name="next"]');
        
        if (!prevButton || !nextButton) return;
        
        // Fonction pour obtenir l'index de l'image active
        const getActiveImageIndex = () => {
          const activeSlide = this.elements.viewer.querySelector('.is-active');
          if (!activeSlide) return 0;
          
          // Sélectionner seulement les slides (li), pas les boutons
          const slides = Array.from(this.elements.viewer.querySelectorAll('li[data-media-id]'));
          return slides.indexOf(activeSlide);
        };
        
        // Fonction pour obtenir le nombre total d'images
        const getTotalImages = () => {
          // Sélectionner seulement les slides (li), pas les boutons
          return this.elements.viewer.querySelectorAll('li[data-media-id]').length;
        };
        
        // Fonction pour naviguer vers l'image suivante/précédente
        const navigateToImage = (direction) => {
          const currentIndex = getActiveImageIndex();
          const totalImages = getTotalImages();
          let newIndex;
          
          if (direction === 'next') {
            newIndex = (currentIndex + 1) % totalImages;
          } else {
            newIndex = (currentIndex - 1 + totalImages) % totalImages;
          }
          
          // Sélectionner seulement les slides (li), pas les boutons
          const slides = Array.from(this.elements.viewer.querySelectorAll('li[data-media-id]'));
          const targetSlide = slides[newIndex];
          
          if (targetSlide) {
            const mediaId = targetSlide.dataset.mediaId;
            this.setActiveMedia(mediaId, false);
          }
        };
        
        // Ajouter les écouteurs d'événements pour desktop uniquement
        const handleDesktopNavigation = (event) => {
          // Vérifier si on est sur desktop ET si c'est le slider des thumbnails
          if (this.mql.matches && this.elements.thumbnails.contains(event.currentTarget)) {
            event.preventDefault();
            event.stopPropagation();
            
            const direction = event.currentTarget.name === 'next' ? 'next' : 'previous';
            navigateToImage(direction);
          }
        };
        
        // Ajouter les écouteurs d'événements avec une priorité élevée
        prevButton.addEventListener('click', handleDesktopNavigation, true);
        nextButton.addEventListener('click', handleDesktopNavigation, true);
        
        // Écouter les changements d'image pour mettre à jour l'état des boutons
        this.elements.viewer.addEventListener('slideChanged', () => {
          setTimeout(() => this.updateDesktopThumbnailButtonStates(), 200);
        });
        
        // Initialiser l'état des boutons au chargement
        setTimeout(() => this.updateDesktopThumbnailButtonStates(), 200);
        
        // Forcer la réactivation des boutons en continu (effet pacman)
        setInterval(() => {
          if (this.mql.matches) {
            this.updateDesktopThumbnailButtonStates();
          }
        }, 100);
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
        
        // Mettre à jour l'état des boutons de navigation des thumbnails sur desktop
        if (this.mql.matches && this.elements.thumbnails) {
          setTimeout(() => {
            this.updateDesktopThumbnailButtonStates();
          }, 200);
        }
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
      
      updateDesktopThumbnailButtonStates() {
        if (!this.elements.thumbnails || !this.mql.matches) return;
        
        const prevButton = this.elements.thumbnails.querySelector('button[name="previous"]');
        const nextButton = this.elements.thumbnails.querySelector('button[name="next"]');
        
        if (!prevButton || !nextButton) return;
        
        // Effet pacman : forcer l'activation des boutons même s'ils sont désactivés par le slider
        prevButton.removeAttribute('disabled');
        nextButton.removeAttribute('disabled');
        
        // S'assurer que les boutons sont cliquables en supprimant les styles disabled
        prevButton.style.pointerEvents = 'auto';
        nextButton.style.pointerEvents = 'auto';
        prevButton.style.opacity = '1';
        nextButton.style.opacity = '1';
      }
    }
  );
}
